import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

/**
 * What the household holds today, in money.
 *
 * A model portfolio only ever says what share of a household a security should
 * be, so this is the balance those shares are read against when the review
 * shows them as amounts rather than weights.
 */
export const FETCH_HOUSEHOLD_MARKET_VALUE = gql`
  query fetchHouseholdMarketValue($clientGroupId: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $clientGroupId }) {
      clientGroup {
        id: stringId
        statistics {
          marketValueCents
          currency
        }
      }
    }
  }
`;

/**
 * Values already stored on the household for the fields this step is showing.
 * Keys are fixed into the document so the selection matches the fields the
 * substep has enabled.
 */
export const fetchHouseholdCustomFields = (keys: readonly string[]) => gql`
  query fetchHouseholdCustomFields($clientGroupId: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $clientGroupId }) {
      clientGroup {
        id: stringId
        customFields(keys: ${JSON.stringify(keys)}) {
          key
          value
          customField {
            id
            type
            format
            objectType
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
          selectedOptions { value displayText { ${TRANSLATED_STRING_FIELDS} } }
        }
      }
    }
  }
`;

export const UPDATE_HOUSEHOLD_CUSTOM_FIELDS = gql`
  mutation updateHouseholdCustomFields($input: UpdateClientGroupInput!) {
    updateClientGroup(input: $input) {
      clientGroup {
        id
      }
    }
  }
`;
